<template>
	<div class="container-xl">
		<main class="py-4">
			<div class="row g-3 mb-4 align-items-center justify-content-between">
				<div class="col-auto">
					<h1 class="app-page-title mb-0">{{ __('schedules.instructor-title') }}</h1>
				</div>
			</div>

			<!-- Planning (vandaag) -->
			<div class="row">
				<div class="col-md-12 mb-2">
					<div class="app-card app-card-orders-table shadow-sm mb-5">
                        <div class="app-card-header p-2 pb-2 border-0">
				            <h4 class="app-card-title">{{ __('schedules.instructor-today') }}</h4>
				        </div>
						<div class="app-card-body">
							<div class="table-responsive" v-if="schedulesToday.length > 0">
								<table class="table app-table-hover mb-0 text-left">
									<thead>
                                        <tr>
                                            <th class="cell">{{ __('form.participant-name-single') }}</th>
                                            <th class="cell">{{ __('form.company-name') }}</th>
                                            <th class="cell">{{ __('form.location') }}</th>
                                            <th class="cell">{{ __('form.session-date-time') }}</th>
                                            <th class="cell">{{ __('form.questionnaire') }}</th>
                                            <th class="cell">{{ __('form.actions') }}</th>
                                        </tr>
									</thead>
									<tbody>
                                        <tr v-for="schedule in schedulesToday" :key="schedule.id + schedule.updated_at">
                                            <td class="cell">{{ schedule.participant_name }}</td>
                                            <td class="cell">{{ schedule.company_name }}
                                                <span v-if="schedule.project_code !== null">
                                                    ({{ schedule.project_code }})
                                                </span>
                                            </td>
                                            <td class="cell">{{ schedule.location }}</td>
                                            <td class="cell">{{ schedule.start_date_formatted }}</td>
                                            <td class="cell">{{ schedule.questionnaire ? schedule.questionnaire.name : '-' }}</td>
                                            <td class="cell">
                                                <button class="btn btn-outline-success me-1" @click="viewSchedule(schedule)">{{ __('actions.view') }}</button>
                                                <a
                                                    class="btn btn-outline-success"
                                                    v-if="!schedule.filled_questionnaire_id"
                                                    :href="'upcoming/' + schedule.id + '/fill'">
                                                    {{ __('actions.fill') }}
                                                </a>
                                            </td>
                                        </tr>
									</tbody>
								</table>
							</div>
                            <div class="p-2" v-else>
                                <h5>{{ __('schedules.no-schedules-instructor-title') }}</h5>
								<p>{{ __('schedules.no-schedules-instructor-text') }}</p>
                            </div>
						</div>
					</div>
				</div>
			</div>

			<!-- Verleden -->
			<div class="row">
				<div class="col-md-12 mb-2">
					<div class="app-card app-card-orders-table shadow-sm mb-5">
                        <div class="app-card-header p-2 pb-2 border-0">
				            <h4 class="app-card-title">{{ __('schedules.instructor-past-week') }}</h4>
				        </div>
						<div class="app-card-body">
							<div class="table-responsive" v-if="schedulesPastWeek.length > 0">
								<table class="table app-table-hover mb-0 text-left">
									<thead>
                                        <tr>
                                            <th class="cell">{{ __('form.participant-name-single') }}</th>
                                            <th class="cell">{{ __('form.company-name') }}</th>
                                            <th class="cell">{{ __('form.location') }}</th>
                                            <th class="cell">{{ __('form.session-date-time') }}</th>
                                            <th class="cell">{{ __('form.questionnaire') }}</th>
                                            <th class="cell">{{ __('form.actions') }}</th>
                                        </tr>
									</thead>
									<tbody>
                                        <tr v-for="schedule in schedulesPastWeek" :key="schedule.id + schedule.updated_at">
                                            <td class="cell">{{ schedule.participant_name }}</td>
                                            <td class="cell">{{ schedule.company_name }}
                                                <span v-if="schedule.project_code !== null">
                                                    ({{ schedule.project_code }})
                                                </span>
                                            </td>
                                            <td class="cell">{{ schedule.location }}</td>
                                            <td class="cell">{{ schedule.start_date_formatted }}</td>
                                            <td class="cell">{{ schedule.questionnaire ? schedule.questionnaire.name : '-' }}</td>
                                            <td class="cell">
                                                <button class="btn btn-outline-success me-1" @click="viewSchedule(schedule)">{{ __('actions.view') }}</button>
                                                <a
                                                    class="btn btn-outline-success"
                                                    v-if="!schedule.filled_questionnaire_id"
                                                    :href="'upcoming/' + schedule.id + '/fill'">
                                                    {{ __('actions.fill') }}
                                                </a>
                                            </td>
                                        </tr>
									</tbody>
								</table>
							</div>
                            <div class="p-2" v-else>
                                <h5>{{ __('schedules.no-past-schedules-instructor-title') }}</h5>
								<p>{{ __('schedules.no-past-schedules-instructor-text') }}</p>
                            </div>
						</div>
					</div>
				</div>
			</div>

			<!-- Vooruitblik -->
            <div class="row">
				<div class="col-md-12 mb-2">
					<div class="app-card app-card-orders-table app-card-future shadow-sm mb-5">
                        <div class="app-card-header p-2 pb-2 app-card-future-title border-0">
				            <h4 class="app-card-title">{{ __('schedules.instructor-future') }}</h4>
				        </div>
						<div class="app-card-body">
							<div class="table-responsive" v-if="schedulesUpcoming.length > 0">
								<table class="table app-table-hover mb-0 text-left">
									<thead>
                                        <tr>
                                            <th class="cell">{{ __('form.participant-name-single') }}</th>
                                            <th class="cell">{{ __('form.company-name') }}</th>
                                            <th class="cell">{{ __('form.location') }}</th>
                                            <th class="cell">{{ __('form.session-date-time') }}</th>
                                            <th class="cell">{{ __('form.questionnaire') }}</th>
                                            <th class="cell">{{ __('form.actions') }}</th>
                                        </tr>
									</thead>
									<tbody>
                                        <tr v-for="schedule in schedulesUpcoming" :key="schedule.id + schedule.updated_at">
                                            <td class="cell">{{ schedule.participant_name }}</td>
                                            <td class="cell">{{ schedule.company_name }}
                                                <span v-if="schedule.project_code !== null">
                                                    ({{ schedule.project_code }})
                                                </span>
                                            </td>
                                            <td class="cell">{{ schedule.location }}</td>
                                            <td class="cell">{{ schedule.start_date_formatted }}</td>
                                            <td class="cell">{{ schedule.questionnaire ? schedule.questionnaire.name : '-' }}</td>
                                            <td class="cell">
                                                <button class="btn btn-outline-success me-1" @click="viewSchedule(schedule)">{{ __('actions.view') }}</button>
                                            </td>
                                        </tr>
									</tbody>
								</table>
							</div>
                            <div class="p-2" v-else>
                                <h5>{{ __('schedules.no-future-schedules-instructor-title') }}</h5>
								<p>{{ __('schedules.no-future-schedules-instructor-text') }}</p>
                            </div>
						</div>
					</div>
				</div>
			</div>
		</main>
		<view-schedule-modal ref="viewScheduleModal"></view-schedule-modal>
	</div>
</template>

<script>
export default {
	name: "UpcomingScheduleComponent",

	props: {
		schedulesToday: {
			type: Array,
			required: true
		},
        schedulesUpcoming: {
            type: Array,
            required: true
        },
        schedulesPastWeek: {
            type: Array,
            required: true
        }
	},

	methods: {
		viewSchedule(schedule) {
			this.$refs.viewScheduleModal.view(schedule);
		}
	}
};
</script>


<style scoped>
.app-card-future-title {
    background-color: rgba(126, 188, 218, 0.23);
}

.app-card-future {
    background-color: rgba(255, 243, 242, 0.7);
}
</style>
